'use client'

import { InfoBanner } from '@vinted/web-ui'
import { useEffect, useRef } from 'react'
import { useFormContext } from 'react-hook-form'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import { ProIntegrationsApplicationFormField } from '../constants'
import { ProIntegrationsApplicationFormModel } from '../types'

const SCROLL_MARGIN_OFFSET = 100

const ApiError = () => {
  const {
    formState: { errors },
  } = useFormContext<ProIntegrationsApplicationFormModel>()
  const ref = useRef<HTMLDivElement>(null)
  const apiError = errors[ProIntegrationsApplicationFormField.ApiError]
  const translate = useTranslate('business.registration.errors.general')

  useEffect(() => {
    ref.current?.scrollIntoView()
  }, [apiError])

  if (!apiError) {
    return null
  }

  return (
    <>
      <div ref={ref} style={{ scrollMarginTop: SCROLL_MARGIN_OFFSET }} />
      <InfoBanner
        testId="pro-integrations-application-form-api-error"
        type={InfoBanner.Type.Error}
        title={translate('title')}
        body={translate('body')}
      />
    </>
  )
}

export default ApiError
